import React from 'react';
import './style.css';

const Agreement: React.FC = () => {
  return (
      <div className="agreement-container">
        <div className="agreement-content">
          <h1>软件使用协议</h1>

          <p>
            本协议是用户（以下简称"您"）与北京紫源科技有限公司（以下简称"我们"）之间就王导导网约车导航小助手软件（以下简称"本软件"）使用等相关事项所订立的有效合约。您通过下载、安装、使用等行为表明您已充分阅读、理解并同意接受本协议的全部条款。
          </p>

          <p>
            您理解并同意，我们会基于法律法规要求及经营需要，适时对本协议进行修改。修改后的协议条款将在本软件内公示，若您在协议修改后继续使用本软件，则视为您接受修改后的协议。如您不同意相关修改，应立即停止使用本软件。
          </p>

          <p>
            您应确保您提供的所有注册信息的真实性、完整性和准确性。如您的信息发生变化，应及时更新。您应妥善保管账号和密码，对您账号下的所有行为负责。如发现任何未经授权使用您账号的情况，应立即通知我们。
          </p>

          <p>
            您在使用本软件过程中应遵守中华人民共和国相关法律法规，不得利用本软件从事任何违法违规活动。您不得从事以下行为：
          </p>

          <ul>
            <li>发布、传播危害国家安全、泄露国家秘密的内容</li>
            <li>发布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的内容</li>
            <li>发布、传播骚扰、诽谤、辱骂、恐吓、侵害他人隐私等内容</li>
            <li>违反知识产权、商业秘密等合法权益的行为</li>
            <li>其他违反法律法规、社会公德的行为</li>
          </ul>

          <p>
            我们致力于保护您的个人信息安全。我们收集、使用您的个人信息将遵循合法、正当、必要的原则，并严格按照隐私政策进行处理。您使用本软件即表示同意我们按照隐私政策收集和使用您的相关信息。
          </p>

          <p>
            本软件的所有权、运营权和知识产权均属于我们所有。未经我们书面许可，任何人不得擅自使用、复制、传播、修改、链接、转载相关内容。
          </p>

          <p>
            如您对本协议或本软件的使用有任何问题，可通过以下方式联系我们：<br />
            邮箱：wuning701122@163.com
          </p>
        </div>
      </div>
  );
};

export default Agreement;
